import React from 'react';
import InstructorCard from './InstructorCard';
import instructors from '../data/instructorsData';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/InstructorCard.css';

const InstructorList = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // PCで3つ表示
    slidesToScroll: 1,
    centerMode: true, // 中央揃え
    centerPadding: '0', // PC画面では余白なし
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // モバイルでは1つ表示
          centerMode: true,
          centerPadding: '0', // モバイル画面では少し余白を追加
        },
      },
    ],
  };


  return (
    <section className="elt-wp-plugin">
      <Slider {...settings} className="instructor-list">
        {instructors.map((instructor, index) => (
          <div key={index} className="instructor-slide">
            <InstructorCard instructor={instructor} />
          </div>
        ))}
      </Slider>
    </section>
  );
};


export default InstructorList;

